const products = [
  {
    id: 1,
    name: "Ноутбук",
    color: "Brown AB632",
    category: "Aspen",
    image:
      "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/AB632-200x200.jpg",
  },
  {
    id: 2,
    name: "Ноутбук",
    color: "Glacier AG612",
    category: "Aspen",
    image:
      "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/7s6q2coey3bvow0p0cksjcfkcqaayb5o-200x200.png",
  },
  {
    id: 3,
    name: "Ноутбук",
    color: "Goldrush AG614",
    category: "Aspen",
    image:
      "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/9a31la31x708pqdvnwjtodhmgkha9jab-200x200.png",
  },
  {
    id: 4,
    name: "Ноутбук",
    color: "Mine AM633",
    category: "Aspen",
    image:
      "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/36e6f980-6fd4-432c-b6d9-7d20547cdf3b-200x200.jpg",
  },
  {
    id: 5,
    name: "Ноутбук",
    color: "Misto AM681",
    category: "Aspen",
    image:
      "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/okn6xj9u7emwixe3b3ho85qbynxqkirr-200x200.jpg",
  },
  {
    id: 6,
    name: "Ноутбук",
    color: "Pepper AP640",
    category: "Aspen",
    image:
      "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/ee15ece7-d043-4a93-88b2-152200443d46-200x200.jpg",
  },
  {
    id: 7,
    name: "Ноутбук",
    color: "Seashell AS642",
    category: "Aspen",
    image:
      "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/8691fb0e-fcea-4ca1-a941-4f1d453ab41c-200x200.jpg",
  },
  {
    id: 8,
    name: "Ноутбук",
    color: "Snow AS610",
    category: "Aspen",
    image:
      "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/1qlrlpgmodr80r6fjjk3wcvm4c02zua8-200x200.png",
  },
  {
    id: 9,
    name: "Ноутбук",
    color: "Beach EB545",
    category: "Metallic",
    image:
      "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/3qzejdtmnet2wch1fu3y2lem0ut2bgxg-200x200.jpg",
  },
  {
    id: 10,
    name: "Ноутбук",
    color: "Cosmos EC596",
    category: "Metallic",
    image:
      "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/et5ti1ciysv8qz20hdm9us6o5iik2grc-200x200.jpg",
  },
  {
    id: 11,
    name: "Ноутбук",
    color: "Satingold ES558",
    category: "Metallic",
    image:
      "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/METALLIC_SATINGOLD_ES558-200x200.jpg",
  },
  {
    id: 12,
    name: "Ноутбук",
    color: "Sleeksilver ES582",
    category: "Metallic",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/3725c7d9-a6b7-4e73-b34f-ef4ea68ba11c-200x200.jpg",
  },
  {
    id: 13,
    name: "Ноутбук",
    color: "Yukon EY510",
    category: "Metallic",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/jnxmxe2ahnxfc02l7rb9qnd3brqp205f-200x200.png",
  },
  {
    id: 14,
    name: "Ноутбук",
    color: "Dalmatian QD212",
    category: "Mosaic",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/bxd1w23ofbctexg5e5m24xlxvcmmjr6f-200x200.jpg",
  },
  {
    id: 15,
    name: "Ноутбук",
    color: "Nimbus QN287",
    category: "Mosaic",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/5c7d060e-ddb6-4585-b06d-9f03fca74711-200x200.jpg",
  },
  {
    id: 16,
    name: "Ноутбук",
    color: "Blue PB870",
    category: "Pebble",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/46cc346d-33c8-4ca0-8f0e-4600774095c6-200x200.jpg",
  },
  {
    id: 17,
    name: "Ноутбук",
    color: "Ebony PE814",
    category: "Pebble",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/0t8hqy7rxtv5we8otbgydtefvnnjdh68-200x200.jpg",
  },
  {
    id: 18,
    name: "Ноутбук",
    color: "Gold PG840",
    category: "Pebble",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/di3bsz2oop37nkogvp4ds0mqtpesz80v-200x200.jpg",
  },
  {
    id: 19,
    name: "Ноутбук",
    color: "Grey PG810",
    category: "Pebble",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/77eda8c6-7f1a-4d5b-9b3c-58e2623fd10d-200x200.jpg",
  },
  {
    id: 20,
    name: "Ноутбук",
    color: "Ice PI811",
    category: "Pebble",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/jzpbooypixxoz3sh2pfsyrou7bqi9fmk-200x200.png",
  },
  {
    id: 21,
    name: "Ноутбук",
    color: "Kernel PK843",
    category: "Pebble",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/9edecc60-9fc8-4644-a7ec-83ee61ed1d59-200x200.jpg",
  },
  {
    id: 22,
    name: "Ноутбук",
    color: "Ponderosa PP868",
    category: "Pebble",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/dfd472bc-6585-4796-93db-bcb095a8ad9c-200x200.jpg",
  },
  {
    id: 23,
    name: "Ноутбук",
    color: "Rose PR850",
    category: "Pebble",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/kgxxof8mck906dv5t60t42734jnkqkmt-200x200.jpg",
  },
  {
    id: 24,
    name: "Ноутбук",
    color: "Saratoga PS820",
    category: "Pebble",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/t3waaeq5io1yxpmd698snkzk3w28j4ur-200x200.jpg",
  },
  {
    id: 25,
    name: "Ноутбук",
    color: "Swan PS813",
    category: "Pebble",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/zra7vj4bqd43gcgsptbw274ia5xd50mj-200x200.png",
  },
  {
    id: 26,
    name: "Ноутбук",
    color: "Terrain PT857",
    category: "Pebble",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/pro7u2kbru6lebv54tthgoap2x9lwc3n-200x200.jpg",
  },
  {
    id: 27,
    name: "Ноутбук",
    color: "Minette QM289",
    category: "Quarry",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/76nqslzinjar31412cz01odr4tnivevi-200x200.jpg",
  },
  {
    id: 28,
    name: "Ноутбук",
    color: "Oyster TO310",
    category: "Quarry",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/x3unss6asildndw4rfb3tjr89hhtx8ge-200x200.jpg",
  },
  {
    id: 29,
    name: "Ноутбук",
    color: "Birch SB412",
    category: "Sanded",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/f5648799-8d1c-4173-b44d-236576779c10-200x200.jpg",
  },
  {
    id: 30,
    name: "Ноутбук",
    color: "Chestnut SC457",
    category: "Sanded",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/e0bd9390-8a70-445f-955a-cc73699b4cc4-200x200.jpg",
  },
  {
    id: 31,
    name: "Ноутбук",
    color: "Cornmeal SC433",
    category: "Sanded",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/p18iw7m7k7x8y6p5ayr8dtqicfw8tyq1-200x200.jpg",
  },
  {
    id: 32,
    name: "Ноутбук",
    color: "Cream SM421",
    category: "Sanded",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/ybbisq23r2fry671jl4cctye7z1p6ern-200x200.png",
  },
  {
    id: 33,
    name: "Ноутбук",
    color: "Dark Nebula DN421",
    category: "Sanded",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/2fjpiy508xamai8kc2rlcex5yysfxykn-200x200.jpg",
  },
  {
    id: 34,
    name: "Ноутбук",
    color: "Gold Dust SG441",
    category: "Sanded",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/8b1ac273-4ab1-45c0-ab1e-128f85d01803-200x200.jpg",
  },
  {
    id: 35,
    name: "Ноутбук",
    color: "Grey SG420",
    category: "Sanded",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/8834lb8fbqgcffpmbuh7c8aqn8u57pb8-200x200.jpg",
  },
  {
    id: 36,
    name: "Ноутбук",
    color: "Icicle SI414",
    category: "Sanded",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/1687a4a1-7d9a-4ac2-b2c5-f5872f801410-200x200.jpg",
  },
  {
    id: 37,
    name: "Ноутбук",
    color: "Mocha SM453",
    category: "Sanded",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/4334441c-a76b-4998-bd65-6bf2d691ffaf-200x200.jpg",
  },
  {
    id: 38,
    name: "Ноутбук",
    color: "Oatmeal SO446",
    category: "Sanded",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/f092c362-ef17-4a36-a890-77052136678f-200x200.jpg",
  },
  {
    id: 39,
    name: "Ноутбук",
    color: "Onyx SO423",
    category: "Sanded",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/asyk37dich89nsypkyh0h0r26vr3pwnc-200x200.png",
  },
  {
    id: 40,
    name: "Ноутбук",
    color: "Sahara SS440",
    category: "Sanded",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/08ff0479-c579-447c-a4f9-9b6bb3e80f69-200x200.jpg",
  },
  {
    id: 41,
    name: "Ноутбук",
    color: "Stratus SS418",
    category: "Sanded",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/c8393024-ae0a-49f7-90f7-21e2bce7bfcc-200x200.jpg",
  },
  {
    id: 42,
    name: "Ноутбук",
    color: "Tundra ST482",
    category: "Sanded",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/zmc9af20p3c5p0t6xesg8tfyaxt2281j-200x200.jpg",
  },
  {
    id: 43,
    name: "Ноутбук",
    color: "Vermillion SV430",
    category: "Sanded",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/d109a58c-ec52-4257-86b5-e41f31352fcc-200x200.jpg",
  },
  {
    id: 44,
    name: "Ноутбук",
    color: "White Pepper WP410",
    category: "Sanded",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/259cf88c-9de1-4ee4-9f5f-f882df8588f3%20(1)-200x200.jpg",
  },
  {
    id: 45,
    name: "Ноутбук",
    color: "Bliss SB022",
    category: "Solid",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/qctr01m4bh8rzqdytb25r4m59dpp8rp6-200x200.png",
  },
  {
    id: 46,
    name: "Ноутбук",
    color: "Bright White BW010",
    category: "Solid",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/7s6q2coey3bvow0p0cksjcfkcqaayb5o-200x200.png",
  },
  {
    id: 47,
    name: "Ноутбук",
    color: "California Poppy SC052",
    category: "Solid",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/vrcrf59b67om72r3howzg0s99nl558s8-200x200.jpg",
  },
  {
    id: 48,
    name: "Ноутбук",
    color: "Dazzling White SD001",
    category: "Solid",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/7s6q2coey3bvow0p0cksjcfkcqaayb5o-200x200.png",
  },
  {
    id: 49,
    name: "Ноутбук",
    color: "Fog SF020",
    category: "Solid",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/ciekrtli4h4rmo90mx20fezc2wqhl245-200x200.png",
  },
  {
    id: 50,
    name: "Ноутбук",
    color: "Ivory SI040",
    category: "Solid",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/q1kdd7mn7kc37l3mkdg1m3xcn7krnx9n-200x200.png",
  },
  {
    id: 51,
    name: "Ноутбук",
    color: "Natural SV041",
    category: "Solid",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/equb8kdrak7eucg74zxozglz0xyoyyuy-200x200.png",
  },
  {
    id: 52,
    name: "Ноутбук",
    color: "Onyx ON095",
    category: "Solid",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/3359gcug88kd10hwax0sfi8x2jh9bufv-200x200.png",
  },
  {
    id: 53,
    name: "Ноутбук",
    color: "Pearl SP011",
    category: "Solid",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/7s6q2coey3bvow0p0cksjcfkcqaayb5o-200x200.png",
  },
  {
    id: 54,
    name: "Ноутбук",
    color: "Quasar White SQ019",
    category: "Solid",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/7s6q2coey3bvow0p0cksjcfkcqaayb5o-200x200.png",
  },
  {
    id: 55,
    name: "Ноутбук",
    color: "Steel ST023",
    category: "Solid",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/zy6ywxv4ixjm4htzbbwb0ixisffnrvp1-200x200.png",
  },
  {
    id: 56,
    name: "Ноутбук",
    color: "Sunflower SS042",
    category: "Solid",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/6d258baf0ded8ca4c599a2a64a4c3d22-200x200.jpg",
  },
  {
    id: 57,
    name: "Ноутбук",
    color: "Beige Granite VB172",
    category: "Supreme",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/7869e164-a68c-4f5d-8e9b-6a4bcefbf391-200x200.jpg",
  },
  {
    id: 58,
    name: "Ноутбук",
    color: "Cloudbank VC118",
    category: "Supreme",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/o7yjx32ghauvts0ngi41f72b0lzx81xm-200x200.jpg",
  },
  {
    id: 59,
    name: "Ноутбук",
    color: "Concerto VC157",
    category: "Supreme",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/849c3550-b39a-4e65-8242-82ab1f91060c-200x200.jpg",
  },
  {
    id: 60,
    name: "Ноутбук",
    color: "Cotton White VC110",
    category: "Supreme",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/n57ted42suox9hdlm6x0tospf36cw0br-200x200.jpg",
  },
  {
    id: 61,
    name: "Ноутбук",
    color: "Dandelion VD175",
    category: "Supreme",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/b8b912db-6f3f-48ea-83fa-e636655ff500-200x200.jpg",
  },
  {
    id: 62,
    name: "Ноутбук",
    color: "Dawn VD126",
    category: "Supreme",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/r466lj426wo9vjcl1sves394xcx4oqup-200x200.jpg",
  },
  {
    id: 63,
    name: "Ноутбук",
    color: "Desert Wind VD173",
    category: "Supreme",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/10bfb0e1-edf5-4da2-aa4d-a4bcfd112ca1-200x200.jpg",
  },
  {
    id: 64,
    name: "Ноутбук",
    color: "Loam VL155",
    category: "Supreme",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/a01ljqo2x3axx2x05voa3583e4eezq5r-200x200.jpg",
  },
  {
    id: 65,
    name: "Ноутбук",
    color: "Magnolia VM143",
    category: "Supreme",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/0895f7d3-d935-4e33-a656-6145150b209f-200x200.jpg",
  },
  {
    id: 66,
    name: "Ноутбук",
    color: "Adamantine FA159",
    category: "Tempest",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/92a390ce-5adb-453e-9f6f-de7c1be8bff4-200x200.jpg",
  },
  {
    id: 67,
    name: "Ноутбук",
    color: "Blaze FB147",
    category: "Tempest",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/a8c96fb8-afa7-4449-bea6-f2af540f929f-200x200.jpg",
  },
  {
    id: 67,
    name: "Ноутбук",
    color: "Bronzestar FB154",
    category: "Tempest",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/b3662ad7-60ad-4a41-9f4a-621a624ba65a-200x200.jpg",
  },
  {
    id: 68,
    name: "Ноутбук",
    color: "Caviar FC188",
    category: "Tempest",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/46e28af7-8c56-4c0e-ad76-c2be4688ccec-200x200.jpg",
  },
  {
    id: 69,
    name: "Ноутбук",
    color: "Cinnamon FC153",
    category: "Tempest",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/fc153_cinnamon-200x200.jpg",
  },
  {
    id: 70,
    name: "Ноутбук",
    color: "Coffee Bean FC158",
    category: "Tempest",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/ba8b52f8-bf18-414f-af35-1fdccafcb0fc-200x200.jpg",
  },
  {
    id: 71,
    name: "Ноутбук",
    color: "Dazzle FD191",
    category: "Tempest",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/w5eqtko2jqq6th0t2fs4v0cjwjwp2m1b-200x200.jpg",
  },
  {
    id: 72,
    name: "Ноутбук",
    color: "Genesis FG174",
    category: "Tempest",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/631f461c-eb12-43ab-81f0-059ba4205eb9-200x200.jpg",
  },
  {
    id: 73,
    name: "Ноутбук",
    color: "Glimmer FG144",
    category: "Tempest",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/37a2c823-02b4-4146-8559-9d34a7ee46f4-200x200.jpg",
  },
  {
    id: 74,
    name: "Ноутбук",
    color: "Gold Leaf FG196",
    category: "Tempest",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/7f1760d7-e12a-4cd0-9c3b-221811e2cb89-200x200.jpg",
  },
  {
    id: 75,
    name: "Ноутбук",
    color: "Horizon FH114",
    category: "Tempest",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/ec6ef1d1-4e2f-4cf0-845b-757141f824e7-200x200.jpg",
  },
  {
    id: 76,
    name: "Ноутбук",
    color: "Igneous FI187",
    category: "Tempest",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/7117866e-8229-4062-ac6b-1671056299f9-200x200.jpg",
  },
  {
    id: 77,
    name: "Ноутбук",
    color: "Meteor FM111",
    category: "Tempest",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/08553c26-f5cb-4ed4-85bf-c828b449c37f-200x200.jpg",
  },
  {
    id: 78,
    name: "Ноутбук",
    color: "Peak FP100",
    category: "Tempest",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/6jh0q9ivmjjcw39nea01st2e40anzfzf-200x200.png",
  },
  {
    id: 79,
    name: "Ноутбук",
    color: "Pinnacle FP112",
    category: "Tempest",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/pinacle-200x200.jpg",
  },
  {
    id: 80,
    name: "Ноутбук",
    color: "Prairie FP142",
    category: "Tempest",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/3325a08b-c030-4ebc-af28-07188bc6f9eb-200x200.jpg",
  },
  {
    id: 81,
    name: "Ноутбук",
    color: "Rattan FR124",
    category: "Tempest",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/3c3d9c67-6355-4e17-a82c-e797bb726e31-200x200.jpg",
  },
  {
    id: 82,
    name: "Ноутбук",
    color: "Shell FS115",
    category: "Tempest",
    image: "https://territoriyakomforta.kg/image/cache/catalog/%D0%9A%D0%90%D0%9C%D0%95%D0%9D%D0%AC/70b854f7-5704-4aea-8ae6-2206fec21979-200x200.jpg",
  },
];

export default products;
